import { styled } from '@mui/material/styles';

export const StyledSummaryCard = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
  background: linear-gradient(
    135deg,
    #f8fafc 0%,
    rgba(239, 246, 255, 0.5) 50%,
    rgba(224, 231, 255, 0.8) 100%
  );
  border-radius: 16px;
  border: 0.5px solid #1e164e14;
  width: 100%;
  min-width: 236px;
  min-height: 140px;
  height: 100%;
  box-sizing: border-box;
  flex: 1 1 0;
  position: relative;

  .info-icon {
    position: absolute;
    top: 16px;
    right: 16px;
  }

  @media only screen and (max-width: 1150px) {
    min-width: 230px;
  }
`;

export const StyledSummary = styled('div')`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(236px, 1fr));
  gap: 16px;
  width: 100%;
  padding: 24px;
  box-sizing: border-box;
  @media only screen and (max-width: 1320px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
